
import CustomImage from '~/components/elements/CustomImage';

export default {
  name: 'BlogCard',
  components: {CustomImage},
  props: {
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: String,
      default: 'lazy',
    },
    bodyPadding: {
      type: String,
      default: '',
    },
  },
  computed: {
    isMqMobile() {
      return this.$mq === 'mobileXs' || this.$mq === 'mobile';
    },
    bodyPaddingStyle() {
      return this.isMqMobile && this.bodyPadding
      ? { 'padding': this.bodyPadding } : {}
    },
  },
}
